import { InformationSection } from './internal/InformationSection'
import { InviteSection } from './internal/InviteSection'
import { SessionSection } from './internal/SessionSection'

export function SessionSettings() {
    return (
        <div className="flex flex-col gap-[10px]">
            <SessionSection />
            <InviteSection />
            <InformationSection />
        </div>
    )
}
